import { PageController } from '@client/components/_core/layout/PageController';
import { LandingPageSections } from '@client/components/_ui/display/landing-page-sections';
import { ORG_CONFIG_PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute } from '@tanstack/react-router';
import { Typography } from 'antd';
import { Settings } from 'lucide-react';
import { useConfigurationLandingItems } from './useConfigurationLandingItems';

export const Route = createFileRoute('/console/$orgId/configuration/')({
    staticData: {
        ui: {
            hideTitle: true,
            widthVariant: 'default',
        },
        permissions: ORG_CONFIG_PERMISSIONS,
    },
    component: ConfigurationHome,
});

// ============================================================================
// Components
// ============================================================================

function WelcomeSection() {
    return (
        <div className="mb-6 overflow-hidden rounded-xl bg-linear-to-br from-accent-600 via-accent-500 to-accent-400 text-white shadow-lg">
            <div className="flex items-start justify-between p-6">
                <div>
                    <div className="mb-1 flex items-center gap-2 text-accent-100">
                        <Settings size={16} />
                        <span className="font-medium text-sm">Settings</span>
                    </div>
                    <Typography.Title level={2} className="mb-0! text-white!">
                        Control centre
                    </Typography.Title>
                </div>
                <div className="hidden opacity-20 sm:block" aria-hidden="true">
                    <Settings size={80} strokeWidth={1} />
                </div>
            </div>
            {/* Page description */}
            <div className="border-white/20 border-t bg-black/10 px-6 py-3">
                <Typography.Text className="text-sm text-white/80">
                    Manage your organisation settings, integrations, and preferences.
                </Typography.Text>
            </div>
        </div>
    );
}

// ============================================================================
// Main Component
// ============================================================================

function ConfigurationHome() {
    const sections = useConfigurationLandingItems();

    return (
        <PageController route={Route}>
            <WelcomeSection />
            <LandingPageSections sections={sections} columns={4} />
        </PageController>
    );
}
